import type { InvoiceBillingSync } from "@/core/pharmacy/types";

const LABELS: Record<InvoiceBillingSync["status"], string> = {
  pending: "Billing en attente",
  synced: "Sync billing OK",
  skipped: "Déjà dans billing",
  failed: "Sync billing échouée",
};

const CLASS: Record<InvoiceBillingSync["status"], string> = {
  pending: "ph-billing-sync--pending",
  synced: "ph-billing-sync--synced",
  skipped: "ph-billing-sync--skipped",
  failed: "ph-billing-sync--failed",
};

export function BillingSyncBadge({ sync }: { sync?: InvoiceBillingSync }) {
  if (!sync) return <span className="text-muted small">—</span>;
  return (
    <span className={`ph-billing-sync-badge ${CLASS[sync.status]}`} title={sync.error}>
      {LABELS[sync.status]}
    </span>
  );
}
